import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IRechnungsVorlagenResponseRow } from 'fa-kt.types';
import { RechnungsVorlagenService } from '../service';

@Component({
  selector: 'fa-kt-rechnungs-vorlagen-list',
  templateUrl: './rechnungs-vorlagen-list.component.html',
  styleUrls: ['./rechnungs-vorlagen-list.component.css'],
})
export class RechnungsVorlagenListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(public rechnungsVorlagen: RechnungsVorlagenService) {}

  public set(rechnungsVorlagen: IRechnungsVorlagenResponseRow) {}
}
